import React from 'react'
import { DOCS_LINKS } from '../constants'

export const DataSourceDocsLink: React.FC = () =>
  DOCS_LINKS.quickstart ? (
    <a
      href={DOCS_LINKS.quickstart}
      target='_blank'
      rel='noreferrer'
      className='d-inline-flex align-items-center zocks-gap-0.375 paragraph-small button-link-medium zocks-text-primary'
    >
      <i className='bi bi-book' />
      Documentation
    </a>
  ) : null
